<div class="access-denied">
  <h1>Access denied</h1>
  <p>
    You are signed in as <strong>{{ username }}</strong> but you have not been
    granted access to BARE Reporting.
  </p>
  <p class="hint">
    Questions? Contact
    <a [href]="'mailto:' + contact.email">{{ contact.name }}</a>
  </p>
  <stena-button
    type="stroked"
    color="primary"
    text="Sign out"
    (buttonClick)="onSignOut()"
  />
</div>
